import { BG_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const LOGOS_ITEM_OPTION = () => ({
  codigo: 1,
  nome: '',
  column: 4,
  tamanho: 'M',
  settings: {
    title: {
      color: '#202020', 
      content: '', 
      font: 'Inter', 
      'font-size': '32px', 
      'font-style': '', 
      weight: ''
    }
  }
})

export const LOGOS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'logos',
    id: id,
    pageId: pageId,
    idLayout: idLayout,
    name: '',
    bg: BG_SCHEMA(),
    items: [LOGOS_ITEM_OPTION()]
  }
}

export const beforeParseLogos = target => {
  commonBeforeParseMethod(target, ['bg'])
  if (target.items && Array.isArray(target.items) && target.items.every(item => Object.hasOwn(item, 'show'))) {
    const filterItems = target.items.filter(item => item.show)
    Object.assign(target, {items: filterItems})
  }
}

export const LOGOS_SECTION = config => ({
  schema: LOGOS_SCHEMA(config),
  beforeParse: beforeParseLogos
})
